import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Card,
  Typography,
  Link as MuiLink,
  CardContent,
  Grid,
  makeStyles,
  Theme,
  Button,
  FormControlLabel,
  Switch,
} from "@material-ui/core";

import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { getUsersAction } from "src/app-redux/management/actions/managementActions";
import { selectUsers } from "src/app-redux/management/managementSlice";
import "moment-timezone";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";

import TabHeader from "src/components/TabHeader/TabHeader";
import { columns } from "./components/columns";
import { rows } from "./components/rows";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { Check, Close } from "@material-ui/icons";
import { Tooltip } from "@mui/material";
import { SettingsRoute } from "src/modules/settings/setting.routes";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
    //lineHeight: "28px",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  link: {
    backgroundColor: "#72CA00",
    padding: "8px",
    borderRadius: "5px",
    color: "white",
    textDecoration: "none",
  },
}));

interface Props {}

export function ListUsers({}: Props): React.ReactElement {
  const classes = useStyles();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const dispatch = useAppDispatch();
  const [usersList, setUsersList] = useState<any>([]);
  const allUsers = useAppSelector(selectUsers); // get Users from Store
  const [pageHeading, setPageHeading] = React.useState<any>("List of Users");
  const [moduleName, setmoduleName] = React.useState<any>(SettingsRoute.title);
  const [isActiveUser, setIsActiveUser] = useState(true);
  useEffect(() => {
    if (allUsers.length > 0) setLoading(false);
  }, [allUsers]);

  useEffect(() => {
    setLoading(true);
    dispatch(getUsersAction());
  }, []);

  useEffect(() => {
    if (rows.length) {
      let transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "firstName"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <>
                    <MuiLink component={Link} to={`/setting/update-user/${row.original.id}`}>
                      {/* <MuiLink component={Link} to={`/users-management/update-user/${tempId}`}> */}
                      {renderedCellValue}
                    </MuiLink>
                  </>
                );
              },
            }
          : column.accessorKey === "isActive"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.isActive ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.isActive ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "isAllowToExportData"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.isAllowToExportData ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.isAllowToExportData ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column
      );
      if (Number(localStorage.getItem("terminalId")) !== 0) {
        transformedColumns = transformedColumns.filter(
          (x: any) => x.accessorKey !== "terminalName"
        );
      }
      setDisplayColumns(transformedColumns);
    }
  }, [usersList]);

  const { height } = UseWindowDimensions();
  let wHeight = 0;
  let gridMaxHeight = 0;
  let dppr = 10;
  wHeight = height - 132;
  gridMaxHeight = height - 200;
  if (height > 700 && height < 900) {
    dppr = 15;
  } else if (height > 900) {
    dppr = 25;
  } else {
    dppr = 10;
  }
  return (
    <>
      <TabHeader link={SettingsRoute.path} module={moduleName} heading={pageHeading} />
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain} style={{ height: wHeight }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={11}>
              <Box mt={1} mb={2} display="flex">
                <Typography className={classes.pageHeading} style={{ marginTop: "4px" }}>
                  {" "}
                  {pageHeading}{" "}
                </Typography>
                <Box style={{ marginLeft: "10px" }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={Boolean(isActiveUser)}
                        onChange={() => setIsActiveUser(!isActiveUser)}
                        name="isActive"
                        color="primary"
                      />
                    }
                    label="Active User"
                    // style={{ float: "right" }}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid item md={1}>
              <MuiLink
                component={Link}
                to={"/setting/add-user"}
                className={`customSubmitBtn ${classes.link}`}
              >
                Add New User
              </MuiLink>
            </Grid>
          </Grid>
          <CommonMaterialGrid
            // checkboxSelection
            defaultPerPageRecord={dppr}
            height={gridMaxHeight}
            loader={loading}
            rows={allUsers?.filter((data) => data.isActive == isActiveUser) || []}
            columns={displayColumns}
            // uniqueId={(usersList: any) => usersList.email}
          />
        </CardContent>
      </Card>
    </>
  );
}
